module.exports = __webpack_public_path__ + "images/Download.fc5b7e3abbb7bc36be40e6eeec4e3987.svg";